import AlertModal from 'molecules/AlertModal'
import { useSession } from 'next-auth/react';
import React from 'react'

function EmployeeScheduleConflict({ 
    title = 'Schedule Conflict for Employee',
    saveLabel = 'Yes', 
    cancelLabel = 'No', 
    onClose, 
    onSave 
}) {
    const { data: session } = useSession();
    const isRM = session?.user?.role?.includes('resource_manager');
    const isAdmin = session?.user?.role?.includes('admin');
    return (
        <AlertModal
            title={title}
            show={true}
            saveLabel={saveLabel}
            cancelLabel={cancelLabel}
            description={
                <span>
                    The allocated employee has a schedule conflict.
                    {isRM || isAdmin ? 'A conflict request will be raised for resolution.' : 'A conflict resolution request will be triggered to Resource Manager.'}
                    <br /><br /> Do you wish to proceed?
                </span>
            }
            onClose={onClose}
            onSave={onSave}
        ></AlertModal>
    )
}

export default EmployeeScheduleConflict